var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(`background:${_vm.color};border-radius:5px;padding:3px 8px;color:var(--hover-text);font-size:12px;${_vm.dot?'width:15px;height:5px;padding:0;':''};${_vm.light?`box-shadow:0 0 3px 1px ${_vm.color};`:''}`)},[_vm._v(" "+_vm._s(_vm.dot?'':_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }